import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerByRecipient, QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { ContactCircleComponent } from '../contact-circle/contact-circle.component';
import { QuestionTitlePipe } from '../question-title.pipe';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { RowDataComponent } from '../row-data/row-data.component';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
    selector: 'que-answers-in-rows',
    imports: [CommonModule, ContactCircleComponent, QuestionTitlePipe, TranslateDirective, TranslatePipe, RowDataComponent],
    templateUrl: './answers-in-rows.component.html',
    styleUrls: ['./answers-in-rows.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswersInRowsComponent implements OnInit {
  @Input()
  questionData?: QuestionData;
  #storeData = inject(DataSummaryStore);
  filterRecipients$ = toSignal(this.#storeData.recipientsToFilterId$.pipe(tap(x => this.filterTheRecipientsById(x))));
  showAll: boolean = false;
  recipients?: AnswerByRecipient[];
  showComparison$ =toSignal(this.#storeData.showComparison$);

  ngOnInit(): void {
  }
  ngOnChanges() {
      this.filterTheRecipients();
  console.log('[answers] qId=', this.questionData?.question?.id,
              'recipients=', this.questionData?.recipients?.length,
              'recipientIds=', (this.questionData?.recipients ?? []).map((r:any) => r?.recipient?.id));
}
  filterTheRecipients() {
    if (this.filterRecipients$()!=undefined) {
      this.recipients =[...this.questionData?.recipients?.filter(r => r.recipient.user.id==this.filterRecipients$())??[]] ;
    }
    else {
      this.recipients = this.questionData?.recipients;
    }
  }

  filterTheRecipientsById(userId?: number) {
    if (userId!=undefined) {
       this.recipients =[...this.questionData?.recipients?.filter(r => r.recipient.user.id==userId)??[]] ;
    }
    else {
      this.recipients = this.questionData?.recipients;
    }
  }

  showHide() {
    this.showAll = !this.showAll;
  }
}
